import { render, staticRenderFns } from "./ShipmentReturnList.vue?vue&type=template&id=5063c57d&"
import script from "./ShipmentReturnList.vue?vue&type=script&lang=js&"
export * from "./ShipmentReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports